const lineSpacings = ['tight', 'normal', 'loose'] as const;

type LineSpacing = typeof lineSpacings[number];

const defaultLineSpacing: LineSpacing = 'normal';

export { defaultLineSpacing, LineSpacing, lineSpacings };
